import React from 'react'
import { IssuingSpendingProfileMdfy } from './issuingSpendingProfileMdfy'

export const IssuingSpendingProfileModify = () => {
  return (
    <IssuingSpendingProfileMdfy />
  )
}
